/**
 * Safe localStorage wrapper that handles SecurityError in browsers like Edge
 * when localStorage access is denied
 */

// Check if localStorage is available
const isLocalStorageAvailable = () => {
  try {
    const testKey = '__storage_test__';
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

// In-memory fallback storage
const memoryStorage = {};

export const safeLocalStorage = {
  getItem: (key) => {
    try {
      if (isLocalStorageAvailable()) {
        return localStorage.getItem(key);
      }
      return memoryStorage[key] || null;
    } catch (e) {
      console.warn('localStorage access denied, using memory fallback');
      return memoryStorage[key] || null;
    }
  },
  
  setItem: (key, value) => {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.setItem(key, value);
      } else {
        memoryStorage[key] = value;
      }
    } catch (e) {
      console.warn('localStorage access denied, using memory fallback');
      memoryStorage[key] = value;
    }
  },
  
  removeItem: (key) => {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.removeItem(key);
      }
      delete memoryStorage[key];
    } catch (e) {
      console.warn('localStorage access denied, using memory fallback');
      delete memoryStorage[key];
    }
  }
};

export default safeLocalStorage;
